import Notification from './Notification';

export default Notification;



// WEBPACK FOOTER //
// ./src/client/Components/Notification/index.js